import { useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, homeRoute } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { InstallButton } from "../components/InstallApp";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to={homeRoute(user.role)} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome, ${u.name}`);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const label = "block text-[10px] font-bold uppercase tracking-[0.25em] text-white/70";
  const input = "mt-2 w-full border border-white/30 bg-white/5 px-4 py-3.5 text-sm text-white placeholder-white/30 focus:outline-none focus:border-white/70 transition-colors duration-200";

  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden bg-[#0b0a0a]">
      <div className="absolute inset-0 bg-cover bg-center grayscale"
        style={{ backgroundImage: "url(/login-showroom.webp)" }} />
      <div className="absolute inset-0 bg-black/80" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-black/40" />

      <div className="relative z-10 flex items-center justify-end border-b border-white/10 px-6 py-6 sm:px-12">
        <img src="/incheon-kia-logo.png" alt="Incheon Kia" className="h-12 sm:h-14 w-auto object-contain" />
      </div>

      <div className="relative z-10 flex flex-1 items-center px-6 sm:px-12">
        <div className="w-full max-w-sm fade-up">
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold leading-[1.05] tracking-tight text-white">
            Test Drive<br />Management
          </h1>
          <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.3em] text-white/60">Sign in to your account</p>
          <div className="mt-5 h-px w-full bg-white/25" />

          <form onSubmit={submit} className="mt-8 space-y-6">
            <div>
              <label className={label}>Email or User ID</label>
              <input data-testid="login-email-input" type="text" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="name@incheonkia.in or user.id" className={input} />
            </div>
            <div>
              <label className={label}>Password</label>
              <div className="relative">
                <input data-testid="login-password-input" type={showPw ? "text" : "password"} required value={password}
                  onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={input + " pr-16"} />
                <button type="button" data-testid="login-show-password-btn" onClick={() => setShowPw(!showPw)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 mt-1 text-[10px] font-bold uppercase tracking-[0.2em] text-white/50 hover:text-white transition-colors duration-150">
                  {showPw ? "Hide" : "Show"}
                </button>
              </div>
            </div>
            <button data-testid="login-submit-button" type="submit" disabled={busy}
              className="group mt-2 flex w-full items-center justify-between bg-[#EA2F13] px-5 py-4 text-sm font-bold uppercase tracking-[0.2em] text-white transition-colors duration-200 hover:bg-[#d02a10] disabled:opacity-60">
              <span>{busy ? "Signing in…" : "Sign In"}</span>
              <span className="text-lg leading-none transition-transform duration-200 group-hover:translate-x-1">→</span>
            </button>
          </form>
          <div className="mt-4"><InstallButton className="flex w-full items-center justify-center gap-2 rounded-xl border border-white/20 bg-white/10 px-4 py-3 text-sm font-bold text-white backdrop-blur" /></div>
        </div>
      </div>

      <div className="relative z-10 border-t border-white/10 px-6 py-5 sm:px-12">
        <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-white/40">Authorized personnel only</p>
      </div>
    </div>
  );
}
